// src/pages/SubscribePage.jsx
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SubscribeButton from "../components/SubscribeButton";
import { isSubscribed } from "../utils/subscription";
import { PLANS } from "../config/payments";

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export default function SubscribePage() {
  const navigate = useNavigate();
  const query = useQuery();

  // Where to send the user after successful payment
  const back = query.get("back") || "/chapter/4";          // keep your current route
  const redirect = query.get("redirect") || "/chapters";

  // If already subscribed, bounce them to 'back' or 'redirect'
  React.useEffect(() => {
    (async () => {
      const ok = await isSubscribed();
      if (ok) navigate(back || redirect, { replace: true });
    })();
  }, [navigate, back, redirect]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-yellow-50 to-purple-100 p-4">
      <div className="w-full max-w-3xl bg-white/95 rounded-2xl p-8 shadow-lg border">
        <h1 className="text-3xl font-extrabold text-center">Unlock Treble Town Premium</h1>
        <p className="text-center text-gray-600 mt-2">
          Choose a pass and start playing premium chapters.
        </p>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4">
          {/* Day Pass */}
          <div className="rounded-2xl border border-gray-200/70 p-6 shadow-sm text-center">
            <div className="text-lg font-semibold">Day Pass</div>
            <div className="mt-2 text-2xl font-bold">₹{Math.round(PLANS.DAY_PASS.amount / 100)}</div>
            <div className="text-gray-500">24 hours</div>
            <div className="mt-4">
              <SubscribeButton plan={PLANS.DAY_PASS}>
                Get Day Pass
              </SubscribeButton>
            </div>
          </div>

          {/* 7-Day Pass */}
          <div className="rounded-2xl border border-gray-200/70 p-6 shadow-sm text-center">
            <div className="text-lg font-semibold">7-Day Pass</div>
            <div className="mt-2 text-2xl font-bold">₹{Math.round(PLANS.WEEK_PASS.amount / 100)}</div>
            <div className="text-gray-500">One week</div>
            <div className="mt-4">
              <SubscribeButton plan={PLANS.WEEK_PASS}>
                Get 7-Day Pass
              </SubscribeButton>
            </div>
          </div>

          {/* Monthly placeholder (replaces Annual) */}
          <div className="rounded-2xl border border-gray-200/70 p-6 shadow-sm text-center">
            <div className="text-lg font-semibold">Monthly</div>
            {/* No price */}
            <div className="mt-2 h-7 text-gray-500">&nbsp;</div>
            <div className="text-gray-500">Coming Soon</div>
            <div className="mt-4">
              {/* Disabled, non-clickable placeholder */}
              <SubscribeButton plan={PLANS.MONTHLY_INR}>
                ₹499/-
              </SubscribeButton>
            </div>
          </div>
        </div>

        <p className="text-center text-xs text-gray-500 mt-6">
          You’ll be redirected to Razorpay to complete your payment securely.
        </p>
      </div>
    </div>
  );
}
